import { apiClient } from './client';

export interface VisitResponse {
  id: number;
  patient_id: number;
  carer_user_id: number;
  carer_name: string;
  arrived_at: string;
  notes: string | null;
  tasks_completed: Array<{
    care_plan_item_id: number;
    care_plan_item_title: string;
    completed: boolean;
  }>;
}

export interface MealLogResponse {
  id: number;
  meal_type: string;
  status: string;
  notes: string | null;
  logged_by_user_id: number;
  logged_by_name: string;
  logged_at: string;
}

export interface DoseLogResponse {
  id: number;
  medication_id: number;
  status: string;
  notes: string | null;
  logged_by_user_id: number;
  logged_by_name: string;
  logged_at: string;
}

export async function logVisit(
  patientId: number,
  notes?: string,
  tasksCompleted?: number[],
): Promise<VisitResponse> {
  const response = await apiClient.post<VisitResponse>(`/patients/${patientId}/visits`, {
    notes: notes ?? null,
    tasks_completed: tasksCompleted ?? [],
  });
  return response.data;
}

export async function logMeal(
  patientId: number,
  mealType: string,
  status: 'eaten' | 'partial' | 'refused',
  notes?: string,
): Promise<MealLogResponse> {
  const response = await apiClient.post<MealLogResponse>(
    `/patients/${patientId}/meals/${mealType}`,
    { status, notes: notes ?? null },
  );
  return response.data;
}

export async function logDose(
  patientId: number,
  medId: number,
  medicationTimeId: number | null,
  status: 'given' | 'refused' | 'missed',
  notes?: string,
): Promise<DoseLogResponse> {
  const response = await apiClient.post<DoseLogResponse>(
    `/patients/${patientId}/medications/${medId}/doses`,
    { medication_time_id: medicationTimeId, status, notes: notes ?? null },
  );
  return response.data;
}

export async function getVisits(patientId: number, limit = 20): Promise<VisitResponse[]> {
  const response = await apiClient.get<VisitResponse[]>(`/patients/${patientId}/visits`, {
    params: { limit },
  });
  return response.data;
}
